import React, { useRef, useEffect } from "react";

const ParticleCursor = () => {
  const canvasRef = useRef(null);
  let particlesArray = [];
  const colors = ["#1d9ae8", "#00ffff", "#ffffff"];

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    class Particle {
      constructor(x, y, size, color) {
        this.x = x;
        this.y = y;
        this.size = size;
        this.color = color;
        this.speedX = (Math.random() - 0.5) * 3;
        this.speedY = (Math.random() - 0.5) * 3;
        this.opacity = 1;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        this.opacity -= 0.02;
      }

      draw() {
        ctx.globalAlpha = this.opacity;
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
        ctx.globalAlpha = 1;
      }
    }

    const createParticles = (x, y) => {
      for (let i = 0; i < 5; i++) {
        const size = Math.random() * 5 + 1;
        const color = colors[Math.floor(Math.random() * colors.length)];
        particlesArray.push(new Particle(x, y, size, color));
      }
    };

    const animateParticles = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particlesArray.forEach((particle, index) => {
        particle.update();
        particle.draw();

        if (particle.opacity <= 0) {
          particlesArray.splice(index, 1);
        }
      });

      requestAnimationFrame(animateParticles);
    };

    const handleMouseMove = (event) => {
      createParticles(event.clientX, event.clientY);
    };

    window.addEventListener("mousemove", handleMouseMove);
    animateParticles();

    window.addEventListener("resize", () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="dark:opacity-100 opacity-30 transition-opacity duration-300"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 9999,
      }}
    />
  );
};

export default ParticleCursor;
